module.exports = __webpack_public_path__ + "img/icon-gold50.2074cf83.png";